<script setup lang="ts">
const localePath = useLocalePath()
</script>

<template>
  <section id="eet" aria-labelledby="eet-title" class="px-4 py-8 lg:pt-12 lg:pb-16">
    <div
      class="bg-optilynx-pink/10 container mx-auto flex max-w-7xl flex-col gap-6 rounded-2xl p-6 md:p-10 xl:flex-row xl:items-center xl:gap-9"
    >
      <div class="min-w-0 flex-1">
        <p class="text-optilynx-pink mb-2 text-sm font-medium">EET 2.0</p>
        <h2 id="eet-title" class="mb-4 text-2xl font-medium md:text-3xl">
          {{ $t('eetPromo.title') }}
        </h2>
        <p class="max-w-4xl text-lg">{{ $t('eetPromo.description') }}</p>
        <p class="mt-3 text-lg">{{ $t('eetPromo.notice') }}</p>
      </div>
      <NuxtLink
        :to="{ path: localePath('/'), hash: '#kontakt' }"
        class="bg-optilynx-pink hover:bg-optilynx-pink-hover inline-flex w-fit shrink-0 items-center gap-2 rounded-xl px-4 py-3 text-white transition-colors"
      >
        {{ $t('eetPromo.contact') }}
        <span aria-hidden="true">→</span>
      </NuxtLink>
    </div>
  </section>
</template>
